import { jwtDecode } from 'jwt-decode';
import { UserData, UserPrompt } from '../models/users/UsersState';
import { BaseService } from './BaseService';
import { IChatVisual } from '../models/users/ChatVisual';
import { Feedback, SurveyAnswers } from '../models/users/ChatUser';
import { CompanyInfo } from '../models/company/Company';

export class UserService extends BaseService {
  public getToken = async (): Promise<string> => {
    const cookie: string | undefined = this.getAccessToken();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const WORKS_TOKEN = params.get('sso_token');

    let token: string | null = null;

    if (cookie) {
      try {
        const user: UserData = jwtDecode(cookie);
        const currentTime = Date.now() / 1000;
        if (user.exp > currentTime && user.userId) {
          token = cookie;
        }
      } catch { }
    }

    if (WORKS_TOKEN != null) {
      const body = {
        token: WORKS_TOKEN,
      };
      const result = await this.getResponseAsync<{ message: string; result: string; status: string }>({
        commandPath: `api/sso`,
        method: 'POST',
        body,
      });
      if (result.status == "Success") token = result.result;
    }
    if (token) this.setAccessToken(token);

    //쿠키값에 정상적으로 들어갔는지 한번 더 체크
    const check = this.getAccessToken();
    if (check) {
      return check
    }
    else throw new Error();
    //return token;
  };

  public getChatVisual = async (latitude?: number, longtitude?: number): Promise<IChatVisual> => {
    const query = new URLSearchParams();
    if (latitude) query.append('latitude', latitude.toString());
    if (longtitude) query.append('longtitude', longtitude.toString());

    const result = await this.getResponseAsync<IChatVisual>({
      commandPath: `api/user/insight`,
      method: 'GET',
      query: query,
    });
    return result;
  };

  public getUserPrompt = async (): Promise<UserPrompt> => {
    const result = await this.getResponseAsync<UserPrompt>({
      commandPath: `api/user/config/prompt`,
      method: 'GET',
    });
    return result;
  };

  public checkUserPrompt = async (): Promise<boolean> => {
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/config/prompt/check`,
      method: 'GET',
    });
    return result;
  };

  public updateUserPrompt = async (prompt: UserPrompt): Promise<boolean> => {
    const body = { ...prompt };
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/config/prompt`,
      method: 'POST',
      body,
    });
    return result;
  };

  public insertFeedback = async (feedback: Feedback): Promise<boolean> => {
    const body = {...feedback};
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/feedback`,
      method: 'POST',
      body,
    });
    return result;
  };

  public insertSurvey = async (answers: SurveyAnswers): Promise<boolean> => {
    const body = {...answers};
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/survey`,
      method: 'POST',
      body,
    });
    return result;
  };

  public getSurvey = async (index: string): Promise<boolean> => {
    const query = new URLSearchParams();
    if (index) query.append('seq', index.toString());
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/survey`,
      method: 'GET',
      query: query,
    });
    return result;
  };

  public getGuideShouldShow = async (key: string): Promise<boolean> => {
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/guide/${key}`,
      method: 'GET',
    });
    return result;
  };

  public setGuideSeen = async (key: string): Promise<boolean> => {
    const result = await this.getResponseAsync<boolean>({
      commandPath: `api/user/guide/${key}/seen`,
      method: 'POST',
    });
    return result;
  };

  public getCompanyInfo = async (): Promise<CompanyInfo> => {
    const result = await this.getResponseAsync<CompanyInfo>({
      commandPath: `api/company/info`,
      method: 'GET',
    });
    return result;
  };
}
